








import { Component, Vue, Emit } from 'vue-property-decorator';
import { ALL_SUBUNITS } from '@/queries/SubUnit';
import SubUnitForm from '@/components/SubUnit/SubUnitForm.vue';
import { GQL_createSubUnitVariables, GQL_createSubUnit } from '@/queries/__generated__/createSubUnit';
import { CURRENT_UNIT } from '@/queries/Application';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_currentUnit, GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { GQL_currentUnitSubUnits } from '@/queries/__generated__/currentUnitSubUnits';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from 'graphql-tag';

const CREATE_SUBUNIT = gql`
  mutation createSubUnit(
    $name: String!,
    $organizationNumber: String!,
    $unitId: ID!,
    $departmentId: ID!,
  ) {
    createSubUnit(
      input: {
        subUnit: {
          name: $name,
          organizationNumber: $organizationNumber,
          unitId: $unitId,
          departmentId: $departmentId,
        }
      }
    ) {
      subUnit {
        id
        organizationNumber
        name
        department {
          id
          name
        }
      }
    }
  },
`;

@Component({
  components: {
    SubUnitForm,
  },
})
export default class SubUnitNew extends Vue {
  @SmartQuery<SubUnitNew, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.data.unitId = data.currentUnit.id;
    },
  }) public currentUnit!: GQL_currentUnit_currentUnit;

  private CREATE_SUBUNIT = CREATE_SUBUNIT;
  private data: GQL_createSubUnitVariables = {
    name: '',
    organizationNumber: '',
    departmentId: '',
    unitId: '',
  };

  @Emit('sub-unit-created')
  public addToCache(store: InMemoryCache, query: {data: GQL_createSubUnit }) {
    const data = (store.readQuery({ query: ALL_SUBUNITS }) as GQL_currentUnitSubUnits);
    if (!data.currentUnit || !query.data.createSubUnit?.subUnit) return;
    const subUnit = query.data.createSubUnit!.subUnit!;
    data.currentUnit.subUnits.push(subUnit);
    store.writeQuery({ query: ALL_SUBUNITS, data });
    return subUnit;
  }
}
